if (!customElements.get('coco-shuffle')) {
  const closeIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 26 24" fill="none"><line x1="1.33273" y1="23.6464" x2="23.9601" y2="1.019" stroke="currentColor"/><line x1="2.03983" y1="0.646416" x2="24.6672" y2="23.2738" stroke="currentColor"/></svg>`;
  const roundedTriangleIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 80.19" fill="currentColor"><path d="M46.4,1.97c1.67-2.62,5.5-2.62,7.17,0l45.75,71.67c1.81,2.83-.22,6.54-3.58,6.54l-91.48,.02c-3.36,0-5.39-3.71-3.59-6.54L46.4,1.97h0Z" /></svg>`;
    
  class CocoShuffle extends HTMLElement {
    constructor() {
      super();
      this.selectedProduct = null;
      this.selectedSize = null;
      this.selectedLength = null;
      this.readyToAdd = false;
      this.gender = this.dataset.gender
      this.colorLabel = this.dataset.colorLabel
      this.indexPrefix = this.dataset.prefix;
      this.mainSelect = this.querySelector('[data-main-select]');
      this.tagColor = this.dataset.tagColor;
      this.saleColor = this.dataset.saleColor;
      this.tagPriceColor = this.dataset.tagPriceColor;
      this.saleWeight = this.dataset.saleWeight;
      this.tagsForTagPriceColor = this.dataset.tagsForTagPriceColor;
    }
    
    connectedCallback() {
      this.products = JSON.parse(this.dataset.productsJson.replace("}]},]", "}]}]")
        .replaceAll('%27', '&apos;')
        .replaceAll('%22', '&quot;')
        );
      this.baseProduct = this.products.find(product => product.tags.find(x => x === 'base_product')) ?? null;
      this.selectedProduct = this.products.find(({ handle }) => window.location.pathname.endsWith(`/products/${handle}`));
      this.customer = this.dataset.customerId || false;
      const initialProductId = this.querySelector('input[data-product-id]:checked')?.dataset?.productId;
      if (this.selectedProduct?.id === this.baseProduct?.id || !this.selectedProduct) {
        this.selectedProduct = this.products.find(x => x.id === initialProductId);
      }
            
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-action="add-to-cart"]') && !this.readyToAdd) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          this.setAttribute('data-options-needed', true);
          this.sendAlgoliaATCEvent();
        }
      });

      this.addDelegatedClickListeners();
      this.createCustomEvents();
      document.addEventListener('DOMContentLoaded', () => {
        // any elements that might not exist yet when the ACE gets added to the DOM
        this.imagesWrapper = this.querySelector('[data-product-images-wrapper]');
        this.displayPrice = [...this.querySelectorAll('[data-display-price]')];
        this.displayOptions = this.querySelector('[data-display-options]');
        this.displayTitle = [...this.querySelectorAll('[data-display-title]')];
        this.colorTitle = [...this.querySelectorAll('[data-color-title')];
        this.mainSelect = this.querySelector('[data-main-select]');
        this.querySelector('[data-form-fieldset]')?.removeAttribute('disabled', true);
        this.quantityInput = this.querySelector('input[name=quantity]');
        this.currencySymbol = Shopify.currency.active == "EUR" ? "€" : "$";
        //if (screen.width > 768) this.desktopAccordions(); //You never know if they'll want it back
        //this.stickyATC(); //You never know if they'll want it back
        this.observeTruemedChanges();
        this.initProductForm()
      });
      
      window.addEventListener('loaded:product-form', () => {
        this.checkReadiness();
        const [colorOption] = this.selectedProduct.options_with_values.filter(option => option.name.toLowerCase().trim() === this.colorLabel);
        this.currentVariant = this.selectedProduct.variants
          .find(({ options }) => options.filter(k => !colorOption?.values?.find(j => j === k))
            .every((x) => window.selectedOptionsToPersist?.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));
        this.populateSelectedProductOptions();
        this.swapOutATC();
      });
      
      const stickyObserver = new IntersectionObserver(([entry]) => {
        const buttons = document.querySelectorAll('button.kl-private-reset-css-Xuajs1');

        buttons.forEach((button) => {
          button.style.display = entry.isIntersecting ? 'none' : '';
        });
      });
      
      const stickyElement = document.querySelector('#StickyAddToCart');
      if (stickyElement) stickyObserver.observe(stickyElement);

      const updateAverageRating = () => {
        const parentElement = document.querySelector('.jdgm-rev-widg');
        
        if (parentElement) {
          const averageRating = parentElement.getAttribute('data-average-rating');
          const summaryAverageElement = document.querySelector('.jdgm-rev-widg__summary-average');

          if (averageRating == null || averageRating == '0.00') {
            document.querySelector('[data-judgeme-review]').style.display = 'none';
            document.querySelector('[data-disclaimer-container]').style.display = 'none';

            judgeme_observer.disconnect();
          }
            
          if (summaryAverageElement && averageRating !== null) {
            summaryAverageElement.textContent = averageRating;

            judgeme_observer.disconnect();
          }
        }
      };

      const judgeme_observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList' && mutation.target.classList.contains('jdgm-rev-widg')) {
            updateAverageRating();
          }
        }
      });

      const targetNode = document.querySelector('#judgeme_product_reviews');
      const config = {
        childList: true,
        subtree: true,
      };

      judgeme_observer.observe(targetNode, config);
    }
      
    initProductForm() {
      const thisOptionSet = [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')].map(({ value }) => value);
      const [colorOption] = this.selectedProduct.options_with_values.filter(option => option.name.toLowerCase().trim() === this.colorLabel);

      if ([...new Set(thisOptionSet)].length >= (this.selectedProduct.options_with_values.length - (colorOption ? 1 : 0))) {
        this.currentVariant = this.selectedProduct.variants
          .find(({ options }) => options.filter(k => !colorOption?.values?.find(j => j === k))
            .every((x) => thisOptionSet.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));
        if (this.currentVariant) {
          this.setOptionsToPersist();
          const sectionWrapper = this.querySelector('[data-section="product-form"]')
          persistOptionsFromWindow(sectionWrapper);
        }
        this.readyToAdd = true;
        this.mainSelect.value = this.currentVariant.id;
        this.populateSelectedProductOptions();
        this.checkReadiness();
        this.swapOutATC();
      } else this.readyToAdd = false;      
      
      [...document.querySelectorAll('[data-show]')].forEach((el) => {
        if (Number(el.dataset.show) === Number(this.selectedProduct.id)) {
          el.style.display = null;
          if (el.closest('content-accordion')) {
            setTimeout(() => {
              this.querySelectorAll('[data-accordion-id].active [data-accordion-content]').forEach((contentElement) => {
                contentElement.style.setProperty('--accordion-content-height', `${contentElement.scrollHeight}px`)
              });
            }, 10);
          }
          if (el.querySelector('swiper-carousel')) {
            setTimeout(() => {
              el.querySelector('swiper-carousel')?.reinit();
            }, 10);
          }
          return;
        }
        el.style.display = 'none';
      });
    }
    
    addDelegatedClickListeners() {
      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;
        
        const currentUrl = new URL(window.location.href);

        const {
          action,
          productId,
          option,
          optionType,
          productHandle,
          index
        } = clickedElement.dataset;
                  
        switch (action) {
          case 'select-thumb':
            this.querySelectorAll('[data-action="select-thumb"].selected')
              .forEach((el) => {
                el.classList.remove('selected');
              });
            clickedElement.classList.add('selected');
            const swiper = document.querySelector('[data-mobile-image-loop]').swiper;
            swiper.slideTo(index)
          break;
          case 'product-select':
            if (productId === this.selectedProduct?.id) return;
            this.readyToAdd = false;
            this.selectedProduct = this.products.find(({ id }) => id === productId);
            this.currentVariant = null;
            this.quantityInput.value = 1
            
            if (this.sizeSelection && !this.currentVariant && this.readyToAdd) {
              this.currentVariant = this.selectedProduct.variants
                .find(({ options }) => {
                  return (
                    options.find((x) => x === this.sizeSelection)
                  )
                });
            }
            if (this.currentVariant) {
              const variantUrl = new URL(this.currentVariant.url, window.location.origin);
              const params = new URLSearchParams(currentUrl.search);
              variantUrl.searchParams.forEach((value, key) => params.set(key, value));
              variantUrl.search = params.toString();
              history.replaceState(this.selectedProduct.title, '', variantUrl);
            } else {
              const productURL = new URL(this.selectedProduct.url, window.location.origin);
              const params = new URLSearchParams(currentUrl.search);
              productURL.searchParams.forEach((value, key) => params.set(key, value));
              params.delete('variant');
              productURL.search = params.toString();
              history.replaceState(this.selectedProduct.title, '', productURL);
            }
            
            [...document.querySelectorAll('[data-show]')].forEach((el) => {
              if (Number(el.dataset.show) === Number(this.selectedProduct.id)) {
                el.style.display = null;
                if (el.closest('content-accordion')) {
                  setTimeout(() => {
                    this.querySelectorAll('[data-accordion-id].active [data-accordion-content]').forEach((contentElement) => {
                      contentElement.style.setProperty('--accordion-content-height', `${contentElement.scrollHeight}px`)
                    });
                  }, 10);
                }
                if (el.querySelector('swiper-carousel')) {
                  setTimeout(() => {
                    el.querySelector('swiper-carousel')?.reinit();
                  }, 10);
                }
                return;
              }
              el.style.display = 'none';
            });
            
            let productUpdate = this.currentVariant == null ? this.selectedProduct : this.currentVariant
            const sectionWrapper = this.querySelector('[data-section="product-form"]')
            sectionWrapper.querySelector('[data-action="add-to-cart"]')?.classList.add('loading');
            const sectionInnerHTML = document.getElementById(`linked-product${productHandle}`).innerHTML;
            sectionWrapper.innerHTML = sectionInnerHTML;
            persistOptionsFromWindow(sectionWrapper);
            this.mainSelect.innerHTML = `${this.selectedProduct.variants.map((variant) => `
              <option 
                value="${variant.id}"
                ${variant.id === this.currentVariant?.id ? 'selected="selected"' : ''}
              >
                ${variant.title} - ${variant.price_money}
              </option>
            `).join('')}`;   
            
            this.initProductForm();
            
            this.populateSelectedProductImages();
            this.populateSelectedProductPrice(productUpdate);
            this.displayTitle.forEach(el => el.innerHTML = this.selectedProduct.title.split(' - ')[0]);
            this.colorTitle.forEach(el => el.innerHTML = ': ' + this.selectedProduct.title.split(' - ')[1]);
          break;                            
          case 'option-choice':
            if (!option) {
              console.error('Input with [data-action="option-choice"] is missing a [data-option="value"] attr');
              return;
            }
            
            this.setOptionsToPersist();
            const optionIndex = this.selectedProduct.options_with_values
              .findIndex(({ values }) => values.find(x => x === option));
            let thisOptionSet = [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')]
              .map(({ value }) => value);
            thisOptionSet[optionIndex] = option;
            
            if (optionType.toLowerCase().includes('size')) {
              this.sizeSelection = option;
            }
            
            this.querySelector(`[data-${optionType.toLowerCase()}-title`).innerHTML = `: ${option}`;
            
            const [colorOption] = this.selectedProduct.options_with_values.filter(
              option => option.name.toLowerCase().trim() === this.colorLabel
            );
            
            if ([...new Set(thisOptionSet)].length >= (this.selectedProduct.options_with_values.length - (colorOption ? 1 : 0))) {
              this.currentVariant = this.selectedProduct.variants.find(({ options }) => 
                options.filter(k => !colorOption?.values?.find(j => j === k))
                  .every(x => thisOptionSet.find(y => y?.toLowerCase().trim() === x?.toLowerCase().trim()))
              );
              this.readyToAdd = true;
            } else {
              this.readyToAdd = false;
            }
            
            this.populateSelectedProductOptions();
            this.swapOutATC();
            window.dispatchEvent(this.variantUpdatedEvent);
            
            if (!this.currentVariant) return;
            this.mainSelect.value = this.currentVariant.id;
            
            const variantUrl = new URL(this.currentVariant.url, window.location.origin);
            const params = new URLSearchParams(currentUrl.search);
            variantUrl.searchParams.forEach((value, key) => params.set(key, value));
            variantUrl.search = params.toString();
            
            history.replaceState(this.selectedProduct.title, '', variantUrl.toString());
            
            const variantImage = [...this.imagesWrapper?.querySelectorAll('[data-variants]') ?? []]
              .find(({ dataset: { variants } }) => variants.includes(this.currentVariant.id));
            
            if (variantImage) {
              this.imagesWrapper.insertBefore(variantImage, wrapper.firstChild);
            }
            
          break;
          case 'scroll-to-reviews':
            const reviewsEl = document.getElementById('judgeme_product_reviews');
            const headerElHeight = document.querySelector('header')?.offsetHeight;

            if (!reviewsEl || !headerElHeight) return;
            const reviewsOffsetTop = reviewsEl.offsetTop - headerElHeight;
            window.scrollTo({ behavior: 'smooth', top: reviewsOffsetTop });
          break;
          case 'select-pack':
            this.quantityInput.value = clickedElement.value
            const packLabel = this.querySelector('[data-bundle-label]');
            packLabel.innerHTML = `: ${clickedElement.dataset.label}`


            this.displayPrice.forEach(el => {
              el.innerHTML = clickedElement.dataset.price > clickedElement.dataset.discountPrice
                ? `
                  <span data-sale-price class="text-thunderbird	empty:hidden">${clickedElement.dataset.discountPrice}</span>
                  <span data-compare-price class="line-through text-primaryDark empty:hidden">${clickedElement.dataset.price}</span>`
                : 
                  `<span data-price class="text-primaryDark empty:hidden">${clickedElement.dataset.price}</span>`;
                parseInt(clickedElement.dataset.discount) > 0 ?  el.insertAdjacentHTML('beforeend', `<span class="text-primaryBrand">${clickedElement.dataset.discount}% bundle savings</span>`) : ``
            });
          break;
          default: break;
        }
      })
    }
    
    setOptionsToPersist() {
      window.selectedOptionsToPersist = [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')].map(({ value }) => value);
    }
    
    checkReadiness() {
      const [colorOption] = this.selectedProduct.options_with_values.filter(option => option.name.toLowerCase().trim() === this.colorLabel);
      const thisOptionSet = [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')].map(({ value }) => value);
      const currentUrl = new URL(window.location.href);

      this.currentVariant = this.selectedProduct.variants
        .find(({ options }) => options.filter(k => !colorOption?.values?.find(j => j === k))
          .every((x) => thisOptionSet.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));
          
      if (this.currentVariant) {
        this.mainSelect.value = this.currentVariant.id;
        const variantUrl = new URL(this.currentVariant.url, window.location.origin);
        const params = new URLSearchParams(currentUrl.search);
        variantUrl.searchParams.forEach((value, key) => params.set(key, value));
        variantUrl.search = params.toString();
        history.replaceState(this.selectedProduct.title, '', variantUrl);
      }
            
      if (!this.selectedProduct || !this.currentVariant) {
        this.readyToAdd = false;
        return;
      }
      
      if ([...new Set(thisOptionSet)].length >= (this.selectedProduct.options_with_values.length - (colorOption ? 1 : 0))) {
        this.readyToAdd = true;
      } else this.readyToAdd = false;      
    }
    
    createCustomEvents() {
      this.productUpdatedEvent = new CustomEvent('coco-shuffle:product-updated', {});
      this.variantUpdatedEvent = new CustomEvent('coco-shuffle:variant-updated', {});
    }
    
    populateSelectedProductImages() {
      this.imagesWrapper.innerHTML = `
        <!-- Mobile Product Images -->
        <div class="relative block md:hidden w-[calc(100vw-32px)] mx-auto overflow-visible">
          <swiper-carousel 
            data-pagination="true" 
            data-mobile-image-loop
            data-centered="true"
            data-centered-bounds="true"
            data-slides-per-view="1"
            data-space-between="8"
            data-product-images
            data-external-nav-buttons="product-slider"
            class=""
          >
            <div data-product-images="main" class="swiper-wrapper mobile-pdp-swiper">
              ${this.selectedProduct.media.map((media, i) => `
              <div class="swiper-slide rounded-lg aspect-[1.42/1] overflow-hidden bg-primaryLight [&_img]:object-contain [&_img]:object-center">
              ${media.media_type == 'video' ? `
                <button role="button" data-drawer-action="open" data-drawer-id="video_${i}" class="absolute w-full h-full z-10 group paused">
                  ${ media.alt.includes('autoplay') ? `` : `<span 
                    data-play 
                    class="
                      absolute
                      w-24
                      h-24
                      top-1/2 
                      left-1/2 
                      flex
                      justify-center
                      items-center
                      -translate-x-1/2  
                      -translate-y-1/2 
                      opacity-100
                      text-primaryLight 
                      transform 
                      rotate-90
                      bg-primaryLight
                      bg-opacity-25
                      border-primaryLight
                      border-[3px]
                      rounded-full
                      transition-all 
                      duration-200  
                      pointer-events-none 
                      group-hover:scale-110
                      [&_svg]:w-12
                      [&_svg]:h-12
                    ">
                    ${roundedTriangleIcon}
                  </span>` }
                  ${media.media_type == 'video' && media.alt.includes('autoplay') ? 
                    `${this.loadImage({ ...media, media_type: media.media_type }, i)}` : 
                    `${this.loadImage({ ...media, media_type: media.media_type }, i, true)}`
                  }
                </button>
                <template data-direction="center" data-drawer-content="video_${i}">
                  <div class="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-primaryLight rounded-lg">
                    <div class="flex items-center px-5 py-2.5">
                    <button 
                        aria-label="Close video modal"
                        role="button" 
                        data-drawer-action="close"
                        data-drawer-id="video_${i}" 
                        class="block w-5 h-5 text-primaryDark absolute right-5 top-2.5"
                      >
                      ${closeIcon}
                      </button>
                    </div>
                    <div class="p-5 max-md:w-screen">
                      ${this.loadImage(media, i)}
                    </div>
                  </div>
                </template>
              ` : this.loadImage(media, i)}     
               ${this.selectedProduct.badge && i === 0 ? 
                  `<div class="absolute top-2 right-2 h-20 w-20">
                    <img class="object-contain" data-badge loading="lazy" src="${this.selectedProduct.badge}" height="auto" width="auto" />
                  </div>` : 
                  `` 
                }           
              </div>
            `).join('')}
            </div>
            <span class="absolute bg-[#efefef] rounded-full left-4 bottom-4 z-10 justify-center items-center flex p-2 md:p-2.5 [&_svg]:w-4 [&_svg]:h-4 ">
              <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.16 13.16"  width="100%" height="100%" stroke="currentColor">
                <path d="M3.81,5.89h2.08m0,0h2.08m-2.08,0V3.81m0,2.08v2.08m4.15,2.08l2.77,2.77M.35,5.89c0,1.47,.58,2.88,1.62,3.92,1.04,1.04,2.45,1.62,3.92,1.62s2.88-.58,3.92-1.62c1.04-1.04,1.62-2.45,1.62-3.92s-.58-2.88-1.62-3.92C8.76,.93,7.35,.35,5.89,.35S3.01,.93,1.97,1.97C.93,3.01,.35,4.42,.35,5.89Z" style="fill: none; stroke: #1c1e1d; stroke-linecap: round; stroke-linejoin: round; stroke-width: .69px;"/>
              </svg>
            </span>
            <div data-pagination class="absolute bottom-0 left-0 z-10 flex gap-1 justify-center [&_.swiper-pagination-bullet]:!m-0 [&_.swiper-pagination-bullet]:bg-[#E2E2E2] [&_.swiper-pagination-bullet-active]:bg-[#B0B0B0]"></div>
          </swiper-carousel>
          <div class="w-full flex justify-between absolute top-1/2 -translate-y-1/2 left-0 px-3 z-10">
            <button class="rounded-full w-7 h-7 flex justify-center items-center disabled:opacity-40" data-prev="product-slider">
              <span class="block h-4 transform -scale-x-100 w-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 11 19" fill="none">
                  <path d="M1 17.5L9 9.5L1 1.5" stroke="currentColor" stroke-width="2"></path>
                </svg>
              </span>
            </button>
            <button class="rounded-full w-7 h-7 flex justify-center items-center disabled:opacity-40"  data-next="product-slider">
              <span class="block h-4 w-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 11 19" fill="none">
                  <path d="M1 17.5L9 9.5L1 1.5" stroke="currentColor" stroke-width="2"></path>
                </svg>
              </span>
            </button>
          </div>
        </div>
        
        <!-- Desktop Product Images -->
        <div class="hidden md:block">
          <div class="grid grid-cols-2 max-xl:grid-cols-1 gap-4 [&_.img]:mix-blend-multiply [&_.img]:w-full" data-product-images="main">
            ${this.selectedProduct.media.map((media, i) => (`
              <div data-index="${i}" class="bg-primaryLight aspect-[1.42/1] md:rounded-lg overflow-hidden ${media.media_type == 'video' ? `cursor-pointer [&>div]:w-auto [&>div]:h-full [&>div]:object-cover [&_img]:w-full [&_img]:h-full [&_img]:object-cover` : `cursor-zoom-in`} relative">
                ${i == 0 ? `<span class="absolute bg-[#efefef] rounded-full left-4 bottom-4 z-10 justify-center items-center flex p-2 md:p-2.5 [&_svg]:w-4 [&_svg]:h-4 ">
                  <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.16 13.16"  width="100%" height="100%" stroke="currentColor">
                    <path d="M3.81,5.89h2.08m0,0h2.08m-2.08,0V3.81m0,2.08v2.08m4.15,2.08l2.77,2.77M.35,5.89c0,1.47,.58,2.88,1.62,3.92,1.04,1.04,2.45,1.62,3.92,1.62s2.88-.58,3.92-1.62c1.04-1.04,1.62-2.45,1.62-3.92s-.58-2.88-1.62-3.92C8.76,.93,7.35,.35,5.89,.35S3.01,.93,1.97,1.97C.93,3.01,.35,4.42,.35,5.89Z" style="fill: none; stroke: #1c1e1d; stroke-linecap: round; stroke-linejoin: round; stroke-width: .69px;"/>
                  </svg>
                </span>` : ``}
                ${media.media_type == 'video' ? `
                  <button type="button" data-drawer-action="open" data-drawer-id="video_${i}" class="absolute w-full h-full z-10 group paused">
                    ${ media.alt.includes('autoplay') ? `` : `<span 
                      data-play
                      class="
                        absolute
                        w-24
                        h-24
                        top-1/2 
                        left-1/2 
                        flex
                        justify-center
                        items-center
                        -translate-x-1/2  
                        -translate-y-1/2 
                        opacity-100
                        text-primaryLight 
                        transform 
                        rotate-90
                        bg-primaryLight
                        bg-opacity-25
                        border-primaryLight
                        border-[3px]
                        rounded-full
                        transition-all 
                        duration-200  
                        pointer-events-none 
                        group-hover:scale-110
                        [&_svg]:w-12
                        [&_svg]:h-12
                      "
                    >
                      ${roundedTriangleIcon}
                    </span>` }
                  </button>
                `
                : ``}
                ${this.selectedProduct.badge && i === 0 ? 
                  `<div class="absolute top-5 right-2 h-24 w-24">
                    <img class="object-contain" data-badge loading="lazy" src="${this.selectedProduct.badge}" height="auto" width="auto" />
                  </div>` : 
                  `` 
                }
                ${media.media_type == 'video' && media.alt.includes('autoplay') ? 
                  `${this.loadImage({ ...media, media_type: media.media_type }, i)}` : 
                  `${this.loadImage({ ...media, media_type: media.media_type }, i, true)}`
                }
              </div>
            `)).join('')}
          </div>
        </div>
      `; 
    }
    
    loadImage(media, i, thumb) {
      // is there a template defined?
      const template = this.querySelector('[data-template="product-image"]')?.innerHTML.toString();
      const { alt, src, variants } = media;
      
      if (media.media_type === 'video') {
        const { alt, poster, sources } = media;
        const source = sources.find(x => x.format === 'mp4');
        let template = false;
        if (!source) return;
        if (thumb){
          template = this.querySelector('[data-template="product-video-thumb"]')?.innerHTML.toString();
        } else {
          template = this.querySelector('[data-template="product-video"]')?.innerHTML.toString();
        }
        let templateString = template.replaceAll('{poster}', poster).replaceAll('{alt}', alt).replaceAll('{source}', source.url).replaceAll('{mime_type}', source.mime_type).replaceAll('{index}', i);
        if (media.alt.includes('autoplay')) {
          templateString = templateString.replaceAll('autoplay="autoplay"', 'autoplay');
        } else {
          templateString = templateString.replaceAll('autoplay="autoplay"', '');
        }

        return templateString; 
      }
      
      if (!template) { 
        return `
          <img height="1200" width="1200" sizes="(min-width:768px) 600px, (min-width:1600px) 800px, (min-width:2000px) 1200px" alt="${alt ? alt : this.selectedProduct.title}" src="${src}">
        `; 
      }
      
      const templateString = template.replaceAll('{src}', src).replaceAll('{alt}', alt).replaceAll('{variants}', variants).replaceAll('{classes}', '').replaceAll('{index}', i);
      return templateString;
    }
    
    populateSelectedProductPrice(product) {
      if (!product || !this.displayPrice) return;
      const shopPay = this.querySelector('shopify-payment-terms')?.shadowRoot.querySelector('#shopify-installments')?.querySelector('#shopify-installments-content');
      setTimeout(() => {
        if(((product?.price / 100).toFixed(2)) > 50 && shopPay != undefined) {
          let splitPrice = ((product?.price / 100) / 4)
          shopPay.innerHTML = `
            Pay in 4 interest-free installments of <b>$${ (Math.round(splitPrice * 100) /100).toFixed(2) }</b> <div class="mobile-injected">with 
            <div class="md:hidden inline-flex align-middle text-purple-primary"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99 25" class="text-inherit h-[14px] w-[59px]"><path fill="currentColor" d="M70.842 7.915h2.25c1.561 0 2.328.642 2.328 1.715 0 1.074-.739 1.715-2.259 1.715h-2.32v-3.43ZM80.525 16.142c-.879 0-1.227-.474-1.227-.948 0-.642.725-.935 2.147-1.102l1.115-.125c-.07 1.227-.892 2.175-2.035 2.175Z"></path><path fill="currentColor" fill-rule="evenodd" d="M65.645.5a3.64 3.64 0 0 0-3.64 3.64V20.7a3.64 3.64 0 0 0 3.64 3.64h29.668a3.64 3.64 0 0 0 3.64-3.64V4.14A3.64 3.64 0 0 0 95.314.5H65.645Zm5.197 16.674v-4.197h2.64c2.412 0 3.695-1.353 3.695-3.402 0-2.05-1.283-3.277-3.695-3.277h-4.341v10.876h1.7Zm9.334.223c1.297 0 2.147-.572 2.538-1.548.112 1.088.767 1.645 2.189 1.269l.014-1.157c-.572.055-.683-.154-.683-.753v-2.845c0-1.673-1.102-2.663-3.138-2.663-2.008 0-3.165 1.004-3.165 2.705h1.562c0-.809.572-1.297 1.576-1.297 1.06 0 1.547.46 1.534 1.255v.363l-1.8.195c-2.021.223-3.137.99-3.137 2.329 0 1.101.781 2.147 2.51 2.147Zm9.906.32c-.711 1.73-1.855 2.245-3.64 2.245h-.766V18.54h.822c.977 0 1.45-.307 1.966-1.185L85.3 9.923h1.757l2.259 5.424 2.008-5.424h1.715l-2.956 7.795Z" clip-rule="evenodd"></path><path fill="currentColor" d="M6.992 11.055c-2.359-.509-3.41-.708-3.41-1.612 0-.85.711-1.274 2.134-1.274 1.25 0 2.165.544 2.839 1.61.05.081.155.11.241.066l2.655-1.335a.186.186 0 0 0 .076-.259c-1.102-1.9-3.137-2.94-5.818-2.94C2.188 5.311 0 7.037 0 9.781c0 2.915 2.664 3.651 5.027 4.16 2.362.51 3.417.709 3.417 1.613s-.769 1.33-2.303 1.33c-1.416 0-2.467-.644-3.102-1.896a.186.186 0 0 0-.251-.082L.14 16.21a.188.188 0 0 0-.083.253c1.051 2.102 3.207 3.285 6.087 3.285 3.668 0 5.885-1.698 5.885-4.527 0-2.83-2.677-3.651-5.037-4.16v-.007ZM21.218 5.311c-1.505 0-2.835.531-3.791 1.477-.06.057-.159.015-.159-.067V.687A.185.185 0 0 0 17.081.5h-3.322a.185.185 0 0 0-.187.187v18.73c0 .104.083.186.187.186h3.322a.185.185 0 0 0 .187-.186V11.2c0-1.587 1.223-2.804 2.87-2.804 1.649 0 2.843 1.191 2.843 2.804v8.216c0 .104.082.186.187.186h3.322a.185.185 0 0 0 .187-.186V11.2c0-3.452-2.274-5.89-5.459-5.89ZM33.415 4.774c-1.803 0-3.493.55-4.706 1.343a.186.186 0 0 0-.06.25l1.464 2.488c.054.089.168.12.257.066a5.853 5.853 0 0 1 3.052-.834c2.899 0 5.03 2.036 5.03 4.726 0 2.292-1.706 3.99-3.868 3.99-1.762 0-2.985-1.022-2.985-2.463 0-.825.352-1.502 1.27-1.98a.183.183 0 0 0 .073-.258l-1.381-2.327a.187.187 0 0 0-.226-.079c-1.85.683-3.15 2.327-3.15 4.533 0 3.338 2.67 5.83 6.396 5.83 4.35 0 7.478-3 7.478-7.303 0-4.612-3.64-7.982-8.644-7.982ZM51.776 5.283c-1.68 0-3.182.62-4.277 1.707a.093.093 0 0 1-.16-.066v-1.31a.185.185 0 0 0-.187-.186h-3.235a.185.185 0 0 0-.188.187v18.702c0 .104.083.186.188.186h3.32a.185.185 0 0 0 .188-.186v-6.133c0-.082.099-.123.16-.07 1.091 1.012 2.536 1.603 4.19 1.603 3.897 0 6.936-3.139 6.936-7.217 0-4.078-3.042-7.217-6.935-7.217Zm-.63 11.266c-2.215 0-3.895-1.754-3.895-4.074S48.928 8.4 51.147 8.4c2.22 0 3.893 1.726 3.893 4.075 0 2.348-1.651 4.074-3.896 4.074h.003Z"></path></svg></div>
            </div>
            <style>
              .mobile-injected {
                display: inline;
              }
              @media (min-width: 768px) {
                .mobile-injected {
                  display: none;
                }
              }
              *:has(>.inline-flex.align-middle.text-purple-primary) .mobile-injected {
                display: none !important;
              }
            </style>
          `
        }
      },0);

      this.displayPrice.forEach(el => {
        if (el.dataset.displayPrice === 'simple') {
          el.innerHTML = product?.price_money;
          return;
        }

        const tags_to_check = this.tagsForTagPriceColor.split(`,`);
        const text_color = tags_to_check.some(tag => this.selectedProduct.tags.includes(tag)) ? this.tagPriceColor : this.saleColor;

        el.innerHTML = product?.compare_at_price > product?.price 
          ? `
            <span data-product-id="${product.id}" data-sale-price class="text-thunderbird	empty:hidden" style="color:${text_color}; font-weight:${this.saleWeight}">${this.currencySymbol}${(product?.price / 100)}</span>
            <span data-product-id="${product.id}" data-compare-price class="line-through text-primaryDark empty:hidden">${this.currencySymbol}${(product?.compare_at_price / 100)}</span>
          `
          : 
          `<span data-price data-product-id="${product.id}" class="text-primaryDark empty:hidden igPrice">${this.currencySymbol}${(product?.price / 100)}</span>`;

        const discount_badges = this.querySelectorAll('[data-tag-messages]');
        const discount_tags = [];
        this.selectedProduct.tags.forEach(tag => {
          if (tag === 'discount-auto' || tag === 'sale') {
            const discount_percent = Math.floor(((product.compare_at_price - product.price) * 100) / product.compare_at_price);
            discount_tags.push(`${discount_percent}% off`);
          } else if (tag.includes('discount-message')) {
            const message = tag.split(' | ').pop();
            discount_tags.push(message);
          }
        });
        
        discount_badges.forEach(discount_badges => {
          discount_badges.classList.remove('hidden');
  
          if (discount_tags.length === 0) {
            discount_badges.classList.add('hidden');
          } else {
            discount_badges.innerHTML = `
              ${discount_tags.map(tag => (`
                <span class="tag-msg bg-orthoBrightGreen p-2 text-primaryLight text-sm rounded-lg" style="--ortho-bright-green:${this.tagColor};">${tag}</span>
              `)).join('')}
            `;
          }
        });
      });
    } 
    
    populateSelectedProductOptions() {
      if (!this.displayOptions || !this.selectedProduct || !this.currentVariant) return;
      this.displayOptions = this.querySelector('[data-display-options]');
      const widths = this.gender == 'women' ? ['Narrow (A)', 'Medium (B)', 'Wide (D)', 'X-Wide (2E)', 'XX-Wide (4E)'] : ['Narrow (B)', 'Medium (D)', 'Wide (2E)', 'X-Wide (4E)', 'XX-Wide (6E)'];
      const optionsHTMLString = this.selectedProduct.options_with_values.map(({ name, values }, index) => {
        const isWidth = ["width", "breite", "largeur"].includes(name.toLowerCase().trim());
        if (values.length < 1) return;
        let colspan = "";
        if (isWidth) {
          const num_options = values.length 
          const by_4 = num_options % 4
          const by_5 = num_options % 5
          if (by_4 == 0) {
            colspan = '[&>*:last-child]:!col-span-6'
          } else if (by_5 == 0) { 
            colspan = '[&>*:nth-last-child(-n+2)]:!col-span-3'
          }
        }
        return `
          <div data-option-type="${name.toLowerCase().trim()}" class="${values.length <= 1 && !isWidth ? 'hidden' : ''}">
            <div class="title-wrap">
              <span class="flex">
                ${name}
                <span data-${name.toLowerCase().trim()}-title class="font-semibold">
                  : ${this.currentVariant.options[index]}
                </span>
              </span>
              ${name.toLowerCase().includes('size') ? `

                <button type="button" data-drawer-action="open" data-drawer-id="size-chart">Size &amp; Fit Chart</button>
              ` : ''}
            </div>
            <div class="selector-section">
              <ul class="selector-list ${colspan}">
                ${values.map((value) => {
                  const indexOfOption = this.selectedProduct.options_with_values
                    .findIndex(({ values }) => {
                      return values.find((x) => x === value);
                    });
                  const currentOptionSet =  [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')].map(({ value }) => value)
                  let thisOptionSet = [...this.currentVariant.options];
                  thisOptionSet[indexOfOption] = value;
                  const matchingProduct = this.selectedProduct.variants.find(({ options}) => {
                    return options.every(( option ) => thisOptionSet.find((thisOption) => thisOption === option));
                  });

                  let matchedWidth = name.toLowerCase().trim() == 'width' && Shopify.country != 'DE' ? widths.find(width => width.startsWith(value)) : value
                          
                  return `
                    <li>
                      <div class="${(matchingProduct?.available && this.readyToAdd || !this.readyToAdd) ? '' : 'unavailable'} selector-wrap">
                        <input 
                          data-action="option-choice"
                          data-option="${value}"
                          data-option-type="${name}"
                          id="${this.selectedProduct.id}-${value}" 
                          type="radio"
                          value="${value}"
                          name="${name}"
                          ${(this.readyToAdd ? (this.currentVariant.options.find((option) => option === value)) : (currentOptionSet.find((option) => option === value))) ? 'checked' : ''}
                        >
                        <span class="selector">    
                          <span class="strikethough">
                            <svg class="relative w-full h-full stroke-orthoBrightGreen" viewBox='0 0 10 10' preserveAspectRatio='none'>
                              <line x1='10' y1='0' x2='0' y2='10' stroke-width='0.5' stroke-opacity='0.5' />
                            </svg>
                          </span>    
                          <span class="selector-label">${matchedWidth}</span>
                        </span>                      
                      </div>
                    </li>
                `
                }).join('')}
              </ul>
            </div>
          </div>`
        }).join('')
      this.displayOptions.innerHTML = optionsHTMLString;
    }
  
    swapOutATC() {
      const atcButton = this.querySelector('[data-action="add-to-cart"]');
      const oosButton = this.querySelector('[data-out-of-stock]');
      const bisButtons = this.querySelectorAll('[data-notify-me]');
      const stickyButton = this.querySelector('[data-sticky-atc-button]');
            
      if (!this.readyToAdd) {
        if (window?.selectedOptionsToPersist) this.setAttribute('data-options-needed', true);
        atcButton.removeAttribute('disabled');
        return;
      }
      
      this.removeAttribute('data-options-needed');
      if (!this.currentVariant) {
        atcButton.setAttribute('disabled', true);
        if (!oosButton) return;
        
        bisButtons.forEach(button => button.classList.remove('peer-disabled:block'));
        oosButton.classList.add('peer-disabled:block');
        oosButton.innerHTML = "Unavailable";
        return;
      }

      bisButtons.forEach(button => button.setAttribute('data-variant-id', this.currentVariant.id));

      this.currentVariant.available ? atcButton.removeAttribute('disabled') : atcButton.setAttribute('disabled', true);
      if (stickyButton) this.currentVariant.available ? stickyButton.innerHTML = "Add to cart" : stickyButton.innerHTML = "Notify me when restocked";
      oosButton.innerHTML = "Out of Stock";

      if (this.currentVariant) {
        oosButton.dataset.variantId = this.currentVariant.id;
      }

      const hideBis = !!this.selectedProduct.tags.find(x => x === 'hide_bis');
      if (hideBis) {
        oosButton?.classList.add('peer-disabled:block');
        bisButtons.forEach(button => button.classList.remove('peer-disabled:block'));
      } else {
        oosButton?.classList.remove('peer-disabled:block');
        bisButtons.forEach(button => button.classList.add('peer-disabled:block'));
      }
    }

    desktopAccordions() {
      const deskOpen = this.querySelectorAll('[data-desk-open]');
      deskOpen.forEach(accordion => {
        accordion.click()
      });
    }

    stickyATC(){ 
      const formButtons = this.querySelector('[data-atc-button]');
      const productForm = this.querySelector('#productForm').offsetTop
      const headerOffset = document.querySelector('site-header').offsetHeight;
      const stickyATC = this.querySelector('[data-sticky-atc]');
      window.addEventListener('scroll', () => {
        if (formButtons.getBoundingClientRect().top <= 0) {
          stickyATC.classList.remove('opacity-0', 'translate-y-full');
        } else {
          stickyATC.classList.add('opacity-0', 'translate-y-full');
        }
      });
      stickyATC.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({
          top: productForm - headerOffset,
          behavior: "smooth",
        });
      })
    }

    observeTruemedChanges() {
      const truemed_container = document.querySelector('[data-truemed-container]');
      const truemed_skeleton = document.querySelector('[data-truemed-skeleton]');

      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            truemed_skeleton.classList.add('hidden');
          }
        }
      });

      observer.observe(truemed_container, {
        childList: true,
        subtree: true, 
      });
    }
  }
    
  customElements.define('coco-shuffle', CocoShuffle);
}